// @ts-nocheck
import logger from "@insite/client-framework/Logger";
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

const apiUrl = "/api/v1/custom/search/categories";

export interface CategorySearchApiParameter extends ApiParameter {
    query: string;
}

export interface CategorySearchItemModel {
    id: string;
    title: string;
    subtitle?: string;
    url?: string;
    smallImagePath?: string;
}

export interface CategorySearchCollectionModel {
    items: CategorySearchItemModel[];
    totalItemCount: number;
}

export const getCategorySearchResults = async (parameter: CategorySearchApiParameter) => {
    try {
        return await get<CategorySearchCollectionModel>(apiUrl, parameter);
    } catch (error) {
        const errorMessage =
            typeof error === "object" && error !== null && "errorMessage" in error
                ? String((error as { errorMessage?: string }).errorMessage || "")
                : String(error);
        logger.warn(`Failed to load category search results: ${errorMessage}`);
        return {
            items: [],
            totalItemCount: 0,
        };
    }
};
